import Vue from "vue";
import { Loading } from "element-ui";
import store from "../../store";
import {homeApis, teacherHomeApis} from "../../api/index";
import course from "./course";
import classSelect from "./classselect";
import videoPlay from "./videoplay";
import classIn from "./classin";
import meeting from "./meeting";
import pageLive from "./classin/pageLive";
const teacher = {
  path: "teacher",
  component: resolve => require(["../../pages/teacher"], resolve),
  children: [
    course,
    classSelect,
    videoPlay,
    classIn,
    meeting,
    pageLive,
  ],
  beforeEnter: (to, from, next) => {
    let token = Vue.prototype.$cookies.get("token");
    if(token){
      let loading = Loading.service();
      teacherHomeApis.basicInfo().then(response => {
        store.dispatch("setUserInfo", response.data.userInfo || {});
        store.dispatch("setPlatformInfo", response.data.platform || {});
        store.dispatch("setClassInfo", response.data.classInfo || {});
        store.dispatch("setUserNavBarImg",response.data.userNavBarImg || "");
      }).finally(() => {
        loading.close();
        next();
      });
    }else{
      next({ path: "/" }); //跳转到登录页
    }
  }
};

export default teacher;



// WEBPACK FOOTER //
// ./src/router/teacher/index.js